<div class="input-select-container">
  <mat-form-field
    class="tenant-search-box"
    [ngClass]="{ 'tenant-search-box-style': !useDefaultStyling }"
    [ngStyle]="inputStyle"
    [appearance]="appearance"
    [style.width]="width || 'unset'">
    <mat-label>{{ placeholder | translate: locale.language }}</mat-label>
    <input
      matInput
      [formControl]="tenantSearch"
      [matAutocomplete]="tenantSuggest"
      [attr.data-test]="'tenant-search'"
      (keyup.enter)="onEnter()" />
    <mat-hint>{{ hint }}</mat-hint>
    @if (tenantSearch.value) {
      <button
        mat-icon-button
        matIconSuffix
        (click)="clearSelectedTenant()"
        [attr.aria-label]="'Clear' | translate: locale.language">
        <mat-icon>clear</mat-icon>
      </button>
    }
  </mat-form-field>
  <mat-autocomplete #tenantSuggest="matAutocomplete" (optionSelected)="onTenantSelect($event.option.value)">
    @for (tenant of tenants(); track tenant.id) {
      <mat-option [value]="tenant" [matTooltip]="tenant.name" [attr.data-test]="'tenant-autocomplete-res-' + $index">
        <small>{{ getTenantFieldValue(tenant) }}</small>
      </mat-option>
    }
  </mat-autocomplete>
</div>
